import { useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";

import { profileLogoSvg } from "../../../assets/svgs/icons/icons.svg";
import { msalInstance } from "../../../configurations/auth/msal.auth.configuration";

import { useTranslation } from "react-i18next";
import { korianLogo } from "../../../assets/svgs/logos/logo_2.svg";
import styles from "./Header.module.scss";
const Header = () => {
  const { accounts } = useMsal()
  const user = accounts[0]
  const email = user?.idTokenClaims?.email as string || 'Email'

  const { t } = useTranslation()
  return (
    <header className={styles.headerTopBar}>
      {/* <article className={styles.headerTopBar__container}> */}
      <section className={styles.headerTopbar__left}>
        <h1>{korianLogo}</h1>
      </section>
      <section className={styles.headerTopbar__right}>
        <Link className={styles.headerTopbar__right__faqButton} to="/FAQ">
          FAQ
        </Link>
        <section className={styles.headerTopbar__right__profileInfo}>
          <section
            className={styles.headerTopbar__right__profileIfo_logo}
          >
            {profileLogoSvg}
          </section>
          <p
            className={styles.headerTopbar__right__profileIfo_nomPrenom}
          >
            {email} 
          </p>
        </section>
        <section className={styles.headerTopbar__right__deconnexion}>
          <a href="/" onClick={async () => {
            localStorage.setItem('accessToken', 'null')
            await msalInstance.logoutRedirect()
          }}>{t('navigation.logout')}</a>
        </section>

      </section>
      {/* </article> */}
    </header>
  );
};

export default Header;
